/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/29/2022.
 */

import * as AppConfigsApi from '../../api/AppConfigs'
import {ASK_FOR_PASSWORD} from "../learningLoop/LearningLoopActions";

export const RECEIVE_APP_CONFIGS = 'RECEIVE_APP_CONFIGS';
export const REQUEST_APP_CONFIGS = 'REQUEST_APP_CONFIGS';
export const SAVE_APP_CONFIGS = 'SAVE_APP_CONFIGS';
export const CLEAR_STATE = 'CLEAR_STATE';
export const CLOSE_PASSWORD_MODAL = 'CLOSE_PASSWORD_MODAL'
export const SUBMIT_PASSWORD = 'SUBMIT_PASSWORD'
export const SUBMIT_PASSWORD_FAILED = 'SUBMIT_PASSWORD_FAILED'
export const REQUEST_TEST_KMS_CONNECTION = 'REQUEST_TEST_KMS_CONNECTION'
export const RECEIVE_TEST_KMS_CONNECTION = 'RECEIVE_TEST_KMS_CONNECTION'
export const REQUEST_LDI_IMPORT_AVAILABILITY = 'REQUEST_LDI_IMPORT_AVAILABILITY'
export const RECEIVE_LDI_IMPORT_AVAILABILITY = 'RECEIVE_LDI_IMPORT_AVAILABILITY'
export const REQUEST_LDI_IMPORT = 'REQUEST_LDI_IMPORT'
export const RECEIVE_LDI_IMPORT = 'RECEIVE_LDI_IMPORT'
export const REQUEST_REVERT_OPTIONS = 'REQUEST_REVERT_OPTIONS'
export const RECEIVE_REVERT_OPTIONS = 'RECEIVE_REVERT_OPTIONS'
export const REQUEST_REVERT_TO_VERSION = 'REQUEST_REVERT_TO_VERSION'
export const RECEIVE_REVERT_TO_VERSION = 'RECEIVE_REVERT_TO_VERSION'
export const REQUEST_MEMORY_REQUIREMENTS = 'REQUEST_MEMORY_REQUIREMENTS'
export const RECEIVE_MEMORY_REQUIREMENTS = 'RECEIVE_MEMORY_REQUIREMENTS'

export const fetchAppConfigs = (ldiId) => dispatch => {
    dispatch(requestAppConfigs());
    return AppConfigsApi.fetchAppConfigs(ldiId).then(
        function (response) {
            dispatch(receiveAppConfigs(response));
            return(response);
        }
    )
}

export const updateAppConfigs = (ldiId, appConfigData) => dispatch => {
    dispatch(updateAppConfigsType(appConfigData));
    return AppConfigsApi.updateAppConfigs(ldiId, appConfigData).then(
        function (response) {
            dispatch(receiveAppConfigs(response));
            return(response);
        }
    )
}

export const requestRunLdiImport = (ldiId, radioValue) => dispatch => {
    dispatch(requestLdiImportFromKms());
    return AppConfigsApi.requestLdiImportFromKms(ldiId, radioValue).then(
        function (response) {
            dispatch(receiveLdiImportFromKms(response));
            return(response);
        }
    )
}

export const ldiImportAvailability = (ldiId) => dispatch => {
    dispatch(requestLdiImportAvailability());
    return AppConfigsApi.requestLdiImportAvailability(ldiId).then(
        function (response) {
            dispatch(receiveLdiImportAvailability(response));
            return(response);
        }
    )
}

export const getRevertOptions = (ldiId) => dispatch => {
    dispatch(requestRevertOptions());
    return AppConfigsApi.requestRevertOptions(ldiId).then(
        function (response) {
            dispatch(receiveRevertOptions(response));
            return(response);
        }
    )
}

export const requestRevertToVersion = (ldiId, version) => dispatch => {
    dispatch(requestRevertToGivenVersion());
    return AppConfigsApi.setRevertOption(ldiId, version).then(
        function (response) {
            dispatch(receiveRevertToGivenVersion(response));
            return(response);
        }
    )
}

export const getMemoryRequirements = (ldiId, flag) => dispatch => {
    dispatch(requestMemoryRequirements());
    return AppConfigsApi.requestMemoryRequirements(ldiId, flag).then(
        function(response) {
            dispatch(receiveMemoryRequirements(response));
            return(response);
        }
    )
}

const requestLdiImportFromKms = () => {
    return {
        type: REQUEST_LDI_IMPORT,
    }
}

const receiveLdiImportFromKms = (data) => {
    return {
        type: RECEIVE_LDI_IMPORT,
        ldiImportResult: data,
    }
}

const requestLdiImportAvailability = () => {
    return {
        type: REQUEST_LDI_IMPORT_AVAILABILITY,
    }
}

const receiveLdiImportAvailability = (data) => {
    return {
        type: RECEIVE_LDI_IMPORT_AVAILABILITY,
        ldiImportAvailabilityResult: data,
    }
}

const requestRevertOptions = () => {
    return {
        type: REQUEST_REVERT_OPTIONS,
    }
}

const receiveRevertOptions = (data) => {
    return {
        type: RECEIVE_REVERT_OPTIONS,
        ldiImportRevertOptions: data,
    }
}

const requestRevertToGivenVersion = () => {
    return {
        type: REQUEST_REVERT_TO_VERSION,
    }
}

const receiveRevertToGivenVersion = (data) => {
    return {
        type: RECEIVE_REVERT_TO_VERSION,
        ldiRevertResult: data,
    }
}

const requestAppConfigs = () => {
    return {
        type: REQUEST_APP_CONFIGS,
    }
}

const receiveAppConfigs = (data) => {
    return {
        type: RECEIVE_APP_CONFIGS,
        appConfigData: data,
    }
}

const updateAppConfigsType = (data) => {
    return {
        type: SAVE_APP_CONFIGS,
        appConfigData: data,
    }
}

const requestMemoryRequirements = () => {
    return {
        type: REQUEST_MEMORY_REQUIREMENTS,
    }
}

const receiveMemoryRequirements = (data) => {
    return {
        type: RECEIVE_MEMORY_REQUIREMENTS,
        memoryRequirements: data,
    }
}

export const testKmsConnection = (ldiId) => dispatch => {
    dispatch(requestTestKmsConnection())
    return AppConfigsApi.testConnection(ldiId).then((res) => {
        dispatch(receiveTestKmsConnection(res.success, {errorKey: res.errorKey}))
    }).catch(err => {
        dispatch(receiveTestKmsConnection(false, err))
    })
}

const requestTestKmsConnection = () => {
    return {
        type: REQUEST_TEST_KMS_CONNECTION,
    }
}

const receiveTestKmsConnection = (success, error) => {
    return {
        type: RECEIVE_TEST_KMS_CONNECTION,
        success: success,
        error: error,
    }
}

export const openPasswordModal = () => dispatch => {
    dispatch(askForPassword())
}

const askForPassword = () => {
    return {
        type: ASK_FOR_PASSWORD,
    }
}

export const submitPassword = (ldiId, password) => dispatch => {
    dispatch(submitPasswordType())
    return AppConfigsApi.submitPassword(ldiId, password).then((response) => {
        dispatch(closePasswordModalType())
        return(response);
    }).catch((err) => {
        if(err.generalError === false) {
            dispatch(submitPasswordFailedType(err))
        } else {
            dispatch(closePasswordModalType());
        }
        throw err;
    })
}

const submitPasswordFailedType = (err) => {
    return {
        type: SUBMIT_PASSWORD_FAILED,
        error: err,
    }
}

const submitPasswordType = () => {
    return {
        type: SUBMIT_PASSWORD,
    }
}

export const closePasswordModal = () => dispatch => {
    dispatch(closePasswordModalType())
}

const closePasswordModalType = () => {
    return {
        type: CLOSE_PASSWORD_MODAL,
    }
}